import routerOptions0 from "/builds/void-zero/clients/mijn-epd/node_modules/.pnpm/nuxt@3.17.2_@parcel+watcher@2.5.1_@types+node@22.15.16_db0@0.3.2_eslint@9.26.0_jiti@2.4_c5ce664d060fbe5735a78455e2c10bdf/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}